/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MovimentoAccasamentoCreateDTO
 */
export interface MovimentoAccasamentoCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof MovimentoAccasamentoCreateDTO
     */
    quantita?: number;
    /**
     * 
     * @type {string}
     * @memberof MovimentoAccasamentoCreateDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoAccasamentoCreateDTO
     */
    valoreFixed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoAccasamentoCreateDTO
     */
    idCapannone?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoAccasamentoCreateDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoAccasamentoCreateDTO
     */
    costoVaccino?: number;
}

/**
 * Check if a given object implements the MovimentoAccasamentoCreateDTO interface.
 */
export function instanceOfMovimentoAccasamentoCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MovimentoAccasamentoCreateDTOFromJSON(json: any): MovimentoAccasamentoCreateDTO {
    return MovimentoAccasamentoCreateDTOFromJSONTyped(json, false);
}

export function MovimentoAccasamentoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MovimentoAccasamentoCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantita': !exists(json, 'quantita') ? undefined : json['quantita'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'valoreFixed': !exists(json, 'valoreFixed') ? undefined : json['valoreFixed'],
        'idCapannone': !exists(json, 'idCapannone') ? undefined : json['idCapannone'],
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'costoVaccino': !exists(json, 'costoVaccino') ? undefined : json['costoVaccino'],
    };
}

export function MovimentoAccasamentoCreateDTOToJSON(value?: MovimentoAccasamentoCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantita': value.quantita,
        'note': value.note,
        'valoreFixed': value.valoreFixed,
        'idCapannone': value.idCapannone,
        'idTipoAnimale': value.idTipoAnimale,
        'costoVaccino': value.costoVaccino,
    };
}

